<template>
  <v-row class="label-bold">
    <div class="row-block">
      <v-col cols="12" sm="2" class="blank-div"></v-col>
      <v-col cols="12" sm="3">
        <div class="test-name-block">
          <div class="ts-label">Test Name:</div>
          <div class="ts-field">
            <v-text-field v-model="testName" dense hide-details></v-text-field>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <div class="test-name-block">
          <div class="ts-label">Test Duration:</div>
          <div class="ts-field">
            <div class="input-number">
              <v-text-field
                v-model="duration"
                min="1"
                type="number"
                @keydown.space.prevent
                @keypress="allowedOnlyNumber($event, true)"
                dense
                hide-details
                suffix="Mins"
              ></v-text-field>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    <div class="row-block">
      <v-col cols="12" sm="2" class="blank-div"></v-col>
      <v-col cols="12" sm="3">
        <div class="test-name-block">
          <div class="ts-label">Target Exam:</div>
          <div class="ts-field">
            <v-select
              v-model="selectedTarget"
              :items="targets"
              class
              dense
              hide-details
              filled
              @change="clearCategory()"
            ></v-select>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        v-if="selectedTarget && patterns && patterns.length > 1"
        class=""
      >
        <div class="test-name-block pattern-radio">
          <div class="ts-label">Pattern:</div>
          
          <div class="column-inline download-option-radio">
            <div
              class="column-radio"
              v-for="(column, index) in patterns"
              :key="index"
            >
              <div class="d-flex" @click="selectedPatterns = column.value">
                <input
                  type="radio"
                  name="downloadOptions"
                  id="downloadOptions"
                  v-model="selectedPatterns"
                  :value="column.value"
                  color="red"
                />
                <label :for="column.value">{{ column.text }}</label>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </div>
    <div class="row-block">
      <v-col cols="12" sm="2" class="blank-div"></v-col>
      <v-col cols="12" sm="7">
        <div class="Select-label with-discard-module">
          <span style="line-height: 24px">Select Category:</span>
          <div v-if="isDummyTest" class="discard-mod-checkbox">
            <v-checkbox v-model="hideModuleQues">
              <template v-slot:label>
                <span class="Select-label" style="margin-bottom: 0">Discard Questions present in Modules</span>
              </template>
            </v-checkbox>
          </div>
        </div>
        <div class="sub-block">
          <v-select
            v-model="selectedClasses"
            :items="getCategory"
            @change="getSubjects()"
            class
            dense
            hide-details
            filled
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    <div class="row-block" v-if="selectedClasses">
      <v-col cols="12" sm="2" class="blank-div"></v-col>
      <v-col cols="12" sm="7">
        <div class="Select-label">Select Subject(s):</div>
        <div class="sub-block">
          <v-autocomplete
            ref="autoSearch"
            v-model="selectedSubjects"
            :items="subjects"
            @change="onSelectSubject"
            dense
            outlined
            hide-details
            chips
            color="blue-grey lighten-2"
            item-text="text"
            item-value="value"
            multiple
          >
            <template v-slot:selection="data">
              <v-chip
                class="name-chip"
                v-model="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="remove(data.item)"
                >{{ data.item.text }}</v-chip
              >
            </template>
          </v-autocomplete>

          <div class="add-field drop-hg-35">
            <!-- <v-select :items="subjects" class="" hide-details dense filled></v-select> -->
          </div>
          <div class="add-field">
            <!-- <v-select :items="itemsdrop" class="" hide-details dense filled></v-select> -->
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    <div
      class="row-block"
      v-if="
        selectedSubjectWithDifficultyLevel.length > 0 &&
          showDifficultyLevel &&
          selectedSubjects &&
          selectedSubjects.length
      "
    >
      <v-col cols="12" sm="2" class="blank-div"></v-col>
      <v-col cols="12" sm="7" class="pd-diff-7">
        <div class="Select-label">Difficulty Level:</div>
        <v-row class="difficulty-subject">
          <v-col
            col="12"
            sm="3"
            class="difficulty-col"
            v-for="subject in selectedSubjectWithDifficultyLevel"
            :key="subject.id"
          >
          <div class="slider-row">
            <div class="sub-block hide-none">
              <!-- Select-label-normal -->
              <!-- <div class=" subject-title-slide Select-label">{{ subject.title }}:</div>
              <v-select
                v-model="subject.difficulty"
                :items="difficulty"
                item-text="title"
                item-value="id"
                hide-details
                dense
                class="fix-200"
                filled
               @change="sliderChange(subject)"
              ></v-select> -->
            </div>
            <!-- {{subject}} -->
            <div class="subject-title-slide Select-label" style="display: flex; align-items: center; justify-content: space-between;">
              <span class="subject-name">{{ subject.title }}:</span>
              <v-tooltip top content-class="cust-new-tooltip-top">
                <template v-slot:activator="{ on }">
                  <div class="max-char" v-on="on" style="width: max-content;">
                    <v-btn 
                      v-on="on" 
                      class="edit-btn"
                      @click="toggleEdit(subject)"
                    >
                      <v-icon size="large" color="black">
                        {{ subject.isDisabled ? 'edit' : 'save' }}
                      </v-icon>
                    </v-btn>
                  </div>
                </template>
                <span >{{ subject.isDisabled ? 'Edit' : 'Save' }}</span>
              </v-tooltip>
               <!-- <v-tooltip top content-class="cust-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  
                </template>
               <span class="v-tooltip__content cust-new-tooltip-bottom open-bottom"
                  style="opacity: 0; top: auto; z-index: 9999; bottom: 0"
                  ></span>
              </v-tooltip> -->
            </div>
            <div class="slider-outer">
              <div class="mx-auto mt-2" max-width="600">
                <div class="wrapper" v-for="(diff, diffIndex) in difficulty" :key="diff.id">
                  <div class="diff-row" >
                    <span class="subheading diff-label">{{ diff.text }}</span>
                    <div>
                      <span v-if="diff.text.toLowerCase() === 'tough' || subject.isDisabled">
                        {{ !subject[diff.text.toLowerCase()] && subject[diff.text.toLowerCase()] !== 0 ? diff.percentage : subject[diff.text.toLowerCase()] }}
                      </span>
                      <input
                        v-if="!subject.isDisabled && diff.text.toLowerCase() !== 'tough'"
                        type="number"
                        :disabled="diff.text.toLowerCase() === 'tough'"
                        v-model="subject[diff.text.toLowerCase()]"
                        @input="updateToughValue(subject)"
                        min="0"
                        max="100"
                        class="percentage-input"
                      />
                      <span class="subheading font-weight-light mr-1">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="3" class="blank-div"></v-col>
    </div>
    
    <template
      v-if="
        showCustomizeSyllabus &&
          selectedPatterns &&
          selectedPatterns.id !== 'custom_pattern'
      "
    >
      
      <div class="row-block">
        <v-col cols="6" sm="2" class="blank-div mb-d-none"></v-col>
        <v-col cols="6" sm="2" class="custom-test-button">
          <div class="circle-icon" @click="openDialog">
            <div v-if="isInstructionsAdded">
              <v-icon>mdi-pencil-circle</v-icon>

              <span>Edit Instructions</span>
            </div>
            <div v-else>
              <v-icon>mdi-plus-circle</v-icon>

              <span>Add Instructions (optional)</span>
            </div>
          </div>
        </v-col>
        <v-col cols="6" sm="5" class="mobile-full-outer">
          <v-btn
            @click="
              processTestData({
                testName,
                duration,
                selectedSubjects:selectedSubjectWithDifficultyLevel,
                selectedTarget,
                selectedClasses,
                selectedPatterns,
                hideModuleQues,
              })
            "
            class="left-btn cust-btn min-125 not-tranform" 
            color="primary"
            :disabled="isSelectedSubjectEditted" 
            >Create Full Test</v-btn
          >
          <v-btn
            @click="
              processTestData(
                {
                  testName,
                  duration,
                  selectedSubjects: selectedSubjectWithDifficultyLevel,
                  selectedTarget,
                  selectedClasses,
                  selectedPatterns,
                  hideModuleQues,
                },
                true
              )
            "
            class="left-btn cust-btn min-125 myt-btn-space not-tranform"
            color="primary"
            :disabled="isSelectedSubjectEditted"
            >Customize Syllabus</v-btn
          >
        </v-col>
      </div>
    </template>
    <div class="row-block" v-else>
      <v-col cols="6" sm="2" class="blank-div"></v-col>
      <v-col cols="6" sm="2" class="custom-test-button">
          <div class="circle-icon" @click="openDialog" v-if="selectedPatterns && selectedPatterns.id !== 'custom_pattern'">
            <div v-if="isInstructionsAdded">
              <v-icon>mdi-pencil-circle</v-icon>

              <span>Edit Instructions</span>
            </div>
            <div v-else>
              <v-icon>mdi-plus-circle</v-icon>

              <span>Add Instructions (optional)</span>
            </div>
          </div>
        </v-col>
       <v-col cols="12" sm="5" >
        <v-btn
          @click="
            processData({
              testName,
              duration,
              selectedTarget,
              selectedClasses,
              selectedPatterns,
              selectedSubjects: selectedSubjectWithDifficultyLevel,
              isOnlineTest: isOnlineTest,
              instructions,
              hideModuleQues,
            })
          "
          class="left-btn cust-btn min-125 not-tranform"
          color="primary"
          :disabled="isSelectedSubjectEditted"
          >{{
            !showCustomizeSyllabus &&
            selectedPatterns &&
            selectedPatterns.id !== "custom_pattern"
              ? "Create Test with Place holders"
              : "Next"
          }}</v-btn
        >
      </v-col>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </v-row>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "PatternI",
  props: ["onNextClick", "data"],
  mounted() {
    this.showCustomizeSyllabus =
      localStorage.getItem("dummyQuestionTest") === "true";
    this.isDummyTest = localStorage.getItem("dummyQuestionTest") === "true";
    this.getClasses();
    this.reqGetTestTargets();
    this.requestGetRefData();
    if (this.data) {
      (async ()=>{
        this.selectedSubjects = null;
        this.duration = this.data.duration;
        this.testName = this.data.testName;
        this.selectedTarget = this.data.selectedTarget;
        this.selectedClasses = this.data.selectedClasses;
        this.selectedPatterns = this.data.selectedPatterns;
        this.hideModuleQues = this.data.hideModuleQues;
        await this.getSubjects();
        const test = _.cloneDeep(this.data.selectedSubjects);
        let difficultyCheck = [];
        this.selectedSubjects = this.selectedSubjects.map((s) => {
          difficultyCheck.push(s);
          delete s.difficulty;
          delete s.easy;
          delete s.moderate;
          delete s.tough;
          delete s.sortBy;
          return s;
        });
        this.selectedSubjectWithDifficultyLevel = this.data.selectedSubjects;
        this.selectedSubjects = test.map((res$)=>{
          return {text : res$.title,value: { ...res$ },checked : true}
        });
      })();
    }
  },
  data() {
    return {
      isDisabled : true,
      subjects: [],
      bpm:0,
      loading: false,
      duration: 0,
      testName: null,
      targets: [],
      selectedSubjects: [],
      modalwidth: null,
      selectedTarget: null,
      classes: [],
      selectedClasses: null,
      difficulty: constants.DIFFICULTY_LEVELS,
      showDifficultyLevel:
        JSON.parse(localStorage.getItem("dummyQuestionTest")) === true,
      selectedSubjectWithDifficultyLevel: [],
      columnType: [
        { text: "Onine", value: 1 },
        { text: "Offline", value: 0 },
      ],
      isOnlineTest: 1,
      patterns: [],
      selectedPatterns: null,
      isRoughWork: true,
      instructions: null,
      cComponent: "",
      status: false,
      questionTypes2: [],
      showCustomizeSyllabus: false,
      alertBoxData: {},
      hideModuleQues: false,
      isDummyTest: false,
    };
  },
  methods: {
    ...mapActions({
      getRefData: "utilStore/getRefData",
      getTestTarget: "utilStore/getTestTarget",
      createCustomTestAPI: "testStore/createCustomTest",
      getOMRPattern: "utilStore/getOMRPattern",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      createTestAPI: "testStore/createTest",

    }),

    toggleEdit(subject) {
    if (subject.isDisabled) {
      // If currently disabled, enable editing
      subject.isDisabled = false;
    } else {
      // If currently editing, save and disable editing
      this.saveDifficulty(subject);
    if((Number(subject?.easy) + Number(subject?.moderate) + Number(subject.tough))>100){
      console.log('true');
      
      this.$toasted.error(`Please check sum for ${subject.title} should be equal to 100%`, {
        icon: "info",
      });

    }
  }
  },

    updateToughValue(subject) {
      const easy = subject.easy || 0;
      const moderate = subject.moderate || 0;
      console.log('easy', easy, 'moderate', moderate);
      

      // Ensure easy + moderate is less than or equal to 100
      const newToughValue = ((100 - (parseInt(easy) + parseInt(moderate))) >= 0 ?  100 - (parseInt(easy) + parseInt(moderate)) : 0);
      subject.tough = newToughValue;
    },
    saveDifficulty(subject){  
      subject.easy = Number(subject.easy);
      subject.moderate = Number(subject.moderate);
      subject.tough = Number(subject.tough);

      subject.isDisabled = true; // Disable editing after saving
    },

    remove(item) {
      const index = this.selectedSubjects.indexOf(item.value);
      if (index >= 0) this.selectedSubjects.splice(index, 1);

      const i = this.selectedSubjectWithDifficultyLevel.indexOf(item.value);
      if (i >= 0) this.selectedSubjectWithDifficultyLevel.splice(i, 1);

      this.onSelectSubject();
    },
    clearCategory() {
      let target = this.targets.find((s) => s.value === this.selectedTarget);

      this.selectedSubjects = null;
      // this.subjects = target.subject_list;
      this.selectedClasses = null;
    },
    reqGetTestTargets() {
      this.getTestTarget({})
        .then((response) => {
          this.loading = false;
           const modules = JSON.parse(localStorage.getItem("modules")) || [];

      const hasValidJEEAdvanceModules = modules.some(
        (m) => m.module_id === 18
      );
      if(hasValidJEEAdvanceModules){
        const targetOrder = [
          constants.TARGET_EXAMS.JEE_MAIN,    // 3
          constants.TARGET_EXAMS.NEET,        // 2
          constants.TARGET_EXAMS.EAMCET,      // 7
          constants.TARGET_EXAMS.KCET,        // 8
          constants.TARGET_EXAMS.MHCET,       // 9
          constants.TARGET_EXAMS.JEE_ADVANCED, // 5
          constants.TARGET_EXAMS.OTHERS       // 10
        ];
        
        this.targets = response
          .filter((x) => targetOrder.includes(x.id))
          .map((x) => {
            let c = { ...x };
            c.text = x.name;
            c.value = x.id;
            c.checked = false;
            return c;
          });
              
        this.targets.sort((a, b) => {
          const indexA = targetOrder.indexOf(a.value);
          const indexB = targetOrder.indexOf(b.value);
          
          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }
          if (indexA !== -1) return -1;
          if (indexB !== -1) return 1;
          return 0;
        });
      }else{
        this.targets = response.filter((x) => x.id !== 5).map((x) => {
            let c = { ...x };
            c.text = x.name;
            c.value = x.id;
            c.checked = false;
            return c;
          
          });
      }
          
        })
        .catch((err) => {
          this.loading = false;
        });
    },
     getSubjects() {
      return new Promise((res,rej)=>{
        this.selectedSubjectWithDifficultyLevel = [];
        // if (!this.selectedPatterns || this.selectedPatterns?.id === "custom_pattern") {
        let reqData = {
          level: 2,
          parent: this.selectedClasses.id,
          target_exam: this.selectedTarget,
        };
        this.subjects = [];
        this.selectedSubjects = null;
        this.$root.showLoader = true;
        this.getDataTreeWithLevel(reqData)
          .then((response) => {
            this.$root.showLoader = false;

            response.map((x) => {
              let c = {};
              let sub =
                this.selectedPatterns && this.selectedPatterns.subject_list
                  ? this.selectedPatterns.subject_list.find((s) => s.id === x.id)
                  : true;
              if (
                (sub && this.selectedPatterns && this.selectedPatterns.id) ||
                this.selectedPatterns.id === "custom_pattern"
              ) {
                if (x.id === constants.BIOLOGY_SUBJECT_ID &&  
                    this.selectedTarget !== constants.TARGET_EXAMS.KCET && 
                    this.selectedTarget !== constants.TARGET_EXAMS.BITSAT && 
                    this.selectedTarget !== constants.TARGET_EXAMS.VITEEE && 
                    this.selectedTarget !== constants.TARGET_EXAMS.SRMJEE && 
                    this.selectedTarget !== constants.TARGET_EXAMS.MHCET) {
                  constants.BIOLOGY_SUBSUBJECTS.map((s) => {
                    let sub = {};

                    sub.text = s.title;
                    sub.value = { ...s };
                    sub.checked = false;
                    this.subjects.push(sub);
                  });
                } else {
                  c.text = x.title;
                  c.value = { ...x };
                  c.checked = false;
                  this.subjects.push(c);
                }
              }else {
                this.subjects = response.map(s=>({text: s.title, value:{...s},checked: false}))
              }
            });
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
        // }
        res();
      })
      
    },
    getClasses() {
      let reqData = {
        level: 1,
      };
      this.classes = [];
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.loading = false;
          this.classes = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x;
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onSelectSubject() {
      if (this.selectedSubjects.length > 0) {
        this.selectedSubjectWithDifficultyLevel = this.selectedSubjectWithDifficultyLevel.filter(
          (item) => {
            return !!this.selectedSubjects.find((s) => {
              return s.id == item.id;
            });
          }
        );
        this.selectedSubjects.map((item) => {
          const e = this.selectedSubjectWithDifficultyLevel.find((s) => {
            return s.id == item.id;
          });
          if (!e) {
            const levels = constants.DIFFICULTY_LEVELS;
            const defaultScores = levels.reduce((acc, level) => {
                acc[level.title.toLowerCase()] = level.percentage;
                return acc;
            }, {});
            this.selectedSubjectWithDifficultyLevel.push({...item,isDisabled : true,...defaultScores});            
          }
        });
      }
    },
    parseJSON(val) {
      try {
        if (typeof val === 'string') return JSON.parse(val);
      } catch (err) {
        console.log('Error parsing json: ', err);
      }

      return val;
    },
    getPatterns() {
      this.$root.showLoader = true;
      this.getOMRPattern({ test_target_id: this.selectedTarget })
        .then((response) => {
          this.patterns = response.map((x) => {
            let c = {};
            c.text = x.pattern_name;
            c.value = {
              ...x,
              test_params: this.parseJSON(x.test_params) || [],
            };
            c.checked = false;
            return c;
          });
          this.selectedPatterns = this.data?.selectedPatterns
            ? this.data.selectedPatterns
            : this.patterns[0].value;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    changePatterns() {
      if (this.data?.selectedPatterns?.id !== this.selectedPatterns?.id) {
        this.selectedSubjects = null;
        this.selectedClasses = null;
      }
      let target = this.targets.find((s) => s.value === this.selectedTarget);
      target =
        (target && {
          ...target,
          subject_ids: this.parseJSON(target.subject_ids),
        }) ||
        null;

      if (
        this.selectedPatterns.subject_list &&
        this.selectedPatterns.subject_list.length &&
        this.data?.selectedPatterns?.id !== this.selectedPatterns?.id
      ) {
        this.subjects = [];

        this.selectedPatterns.subject_list.map((x) => {
          let c = {};
          // let sub = target.subject_ids.includes(x.id);
          // if (sub) {
          if (x.id === constants.BIOLOGY_SUBJECT_ID && 
              this.selectedTarget !== constants.TARGET_EXAMS.KCET && 
              this.selectedTarget !== constants.TARGET_EXAMS.BITSAT && 
              this.selectedTarget !== constants.TARGET_EXAMS.VITEEE && 
              this.selectedTarget !== constants.TARGET_EXAMS.SRMJEE && 
              this.selectedTarget !== constants.TARGET_EXAMS.MHCET) {
            constants.BIOLOGY_SUBSUBJECTS.map((s) => {
              let sub = {};

              sub.text = s.title;
              sub.value = { ...s };
              sub.checked = false;
              this.subjects.push(sub);
            });
          } else {
            c.text = x.title;
            c.value = { ...x };
            c.checked = false;
            this.subjects.push(c);
          }
          // }
        });
      }
    },
    openDialog() {
      this.cComponent =
        "components/coordinator/Tests/CustomizedTests/AddInstructions";
      this.modalwidth = "1000px";
      this.status = true;
      this.persistent = false;
      this.alertBoxData = { instructions: this.instructions };
    },
    onClose(data) {
      this.status = data.status;
      if (
        !data.fromAlertBox &&
        data &&
        (data.instructions || data.instructions == "")
      ) {
        this.instructions = data.instructions;
      }
      if (data.confirm) {
        this.processTestData(
          {
            testName: this.testName,
            duration: this.duration,
            selectedSubjects: this.selectedSubjectWithDifficultyLevel,
            selectedTarget: this.selectedTarget,
            selectedClasses: this.selectedClasses,
            selectedPatterns: this.selectedPatterns,
          },
          false,
          data.confirm
        );
      }
    },

    getChaptersForAllSubjects() {
      let subjectIds = this.selectedSubjects.map((subject) =>
        this.getSubjectId(subject)
      );
      let reqData = {
        level: 3,
        parent_ids: subjectIds,
      };
      this.$root.showLoader = true;

      return this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          let subjectChapterId = {};
          this.selectedSubjects.map((subject) => {
            let sub = response.find(
              (s) => s.parent == subject.id || s.sub_subject === subject.code
            );
            subjectChapterId[subject.id] = {
              chapterId: sub.id,
            };
          });
          return subjectChapterId;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    async processTestData(data, nextPage, confirmation = false) {
      let chapterId = 0,
        questions = [],
        questionNo = 0,
        subIndex = 0,
        optionalQuestionsList = [];
      if (this.validate(data)) {
        let subjectChapterId = await this.getChaptersForAllSubjects();
        this.selectedSubjectWithDifficultyLevel.map((s) => {
          let currentSubjectId =
            this.selectedSubjectWithDifficultyLevel &&
            this.selectedSubjectWithDifficultyLevel[0]
              ? this.getSubjectId(this.selectedSubjectWithDifficultyLevel[0])
              : 0;
          let sub_subject;
          this.selectedPatterns.test_params.map((p, index) => {
            if (
              p.question_type_id != this.QUE_TYPES.COMPREHENSION &&
              p.question_type_id != this.QUE_TYPES.TC &&
              p.optional_question &&
              parseInt(p.optional_question.no_of_mandatory_questions) <
                parseInt(p.optional_question.number_of_question) &&
              p.subject_ids.includes(currentSubjectId)
            ) {
              let queData = this.selectedPatterns.test_params[index];
              let newQueData = optionalQuestionsList.findIndex(
                (c) =>
                  c &&
                  c.questionType === queData.question_type_id &&
                  c.subject === this.getSubjectId(s)
              );
              let newMandatoryQueObj = {};
              newMandatoryQueObj = {
                noOfMandatoryQuestions: parseInt(
                  p.optional_question.no_of_mandatory_questions
                ),
                allowAll: parseInt(p.optional_question.allow_all),
                numberOfQuestions: parseInt(
                  p.optional_question.number_of_question
                ),
                mandatoryQuestionId: null,
                questionType: p.question_type_id,
                subType: p.question_subType_id,
                subject: this.getSubjectId(s),
                sub_subject: s && s.code ? s.code : "null",
              };
              optionalQuestionsList.push(newMandatoryQueObj);
            }
            if (currentSubjectId != s.id && !this.checkBiology(s)) {
              currentSubjectId = this.getSubjectId(s);
              ++subIndex;
            } else if (this.checkBiology(s) && sub_subject !== s.code) {
              sub_subject = s.code;
              ++subIndex;
            }
            if (
              p.subject_ids.includes(this.getSubjectId(s)) ||
              (this.selectedPatterns.id === 15 &&
                ((p.subject_ids[0].length &&
                  p.subject_ids[0].includes(this.getSubjectId(s))) ||
                  (p.subject_ids[1].length &&
                    p.subject_ids[1].includes(this.getSubjectId(s))) ||
                  (p.subject_ids[2].length &&
                    p.subject_ids[2].includes(this.getSubjectId(s))) ||
                  (this.selectedSubjects.length === 1 &&
                    p.subject_ids[2].includes(this.getSubjectId(s)))))
            ) {
              let currentQuestion = {
                index: questionNo,
                subIndex: subIndex,
                subject: s,
                chapterId: subjectChapterId[s.id].chapterId,
                selectedSubType: p.question_subType_id,
                question_text: this.DUMMYTEXT,
                solution: this.DUMMYTEXT,
                correct_answer: null,
                options: [],
                options_abc: [],
                options_pqr: [],
                hints: [{ text: this.DUMMYTEXT }],
                questions: [],
                startValue: null,
                endValue: null,
                questionType: p.question_type_id,
                subtype: p.question_subType_id,
                correctMarkingSchema: p.positive_marks,
                inCorrectMarkingSchema: p.negative_marks || 0,
                partialMarking: p.partial_marking,
                required_questions: parseInt(p.number_of_question),
                l1_questions_required:s.easy,
                l2_questions_required:s.moderate,
                l3_questions_required:s.tough,
              };

              //   currentQuestion = this.setDummyAnswerAsPerType(currentQuestion);
              questions.push(currentQuestion);
              questionNo++;
            }
          });
        });
        data.duration = this.duration;
        let questionList = questions; //removing getQuestionArray(questions)
        if (nextPage) {
          this.onNextClick({
            ...data,
            data: {
              ...data,
              questionList,
              optionalQuestionsList,
            },
            questionList,
            optionalQuestionsList,
            lastStep: true,
          });
        } else {
          this.createCustomTest(
            questionList,
            optionalQuestionsList,
            confirmation
          );
        }
      }
    },
    createCustomTest(questions, optionalQuestionsList, confirmation) {
      console.log("questionsppppp", questions);
      this.$root.showLoader = true;
      let { list, forUpdate } = this.createTestData(
        { questions, optionalQuestionsList },
        confirmation,
        true
      );
      let isOnline = localStorage.getItem("isOnlineTest");

      let reqData = {
        list: list,
        target_exam: this.selectedTarget,
        test_type: this.testType ? this.testType : this.TEST_TYPE.CUSTOM,
        test_sub_type: this.TEST_SUB_TYPES.CUSTOM,
        test_pattern: this.selectedPatterns.id,
        duration: this.duration,
        test_name: this.testName,
        optionalQuestionsList: optionalQuestionsList,
        instructions: this.instructions || "",
        pattern: this.selectedPatterns,
        is_online_test: isOnline === "Online" ? 1 : 0,
        hideModuleQues: this.hideModuleQues,
      };
      if (forUpdate) {
        reqData.only_question = true;
      }
      //   if (stepOneData.testId) {
      //     reqData.id = stepOneData.testId;
      //   }
      if (confirmation) {
        reqData.allowed_dummy_question = true;
      }
      this.createCustomTestAPI(reqData)
        .then((response) => {
          this.loading = false;
          let subjectCustomMsg = [];
          if (response.code === 204) {
            this.$root.showLoader = true;
            response.list.map((s) => {
              subjectCustomMsg.push(
                `${s.required_dummy_questions} questions of ${
                  s.sub_type
                    ? this.questionTypes2.find((q) => q.value.id === s.sub_type)
                        .text
                    : this.questionTypes2.find(
                        (q) => q.value.id === s.question_type_id
                      ).text
                } from  ${
                  this.selectedSubjects.find(
                    (sub) =>
                      sub.id === s.subject_id || sub.code === s.sub_subject
                  ).title
                }`
              );
            });
            this.alertBoxData = subjectCustomMsg;
            this.cComponent =
              "components/coordinator/Tests/CustomizedTests/customizedTestAlertBox";
            this.modalwidth = "525px";
            this.status = true;
            this.$forceUpdate();
          } else {
            this.$root.showLoader = false;

            this.$toasted.success(`Success\n${response.msg}`, {
              icon: "check_circle",
            });
            if (forUpdate) {
              this.onClose({
                status: false,
                reloadPreview: true,
              });
            } else {
              this.$router.push({ name: "customized-tests",query:{tab:isOnline} });
              this.setRouteDetails({ routeName:"customized-tests", selectedTab: isOnline });
            }
          }
          this.disableCreateTest = false;

          this.$root.showLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$root.showLoader = false;
          this.disableCreateTest = false;
        });
    },
    validate(data) {
      let subject_ids = [];
      if (!data || !data.testName || data.testName.trim().length === 0) {
        this.$toasted.error(`Please enter test name`, {
          icon: "info",
        });
        return false;
      } else if (data && data.testName && data.testName.trim().length > 50) {
        this.$toasted.error(
          `Test Name should not contain more than 50 characters`,
          {
            icon: "info",
          }
        );
        return false;
      } else if (!data.duration || data.duration < 1) {
        this.$toasted.error(`Please enter duration`, { icon: "info" });
        return false;
      } else if (!data.selectedTarget || data.selectedTarget.length === 0) {
        this.$toasted.error(`Please select exam target`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedPatterns) {
        this.$toasted.error(`Please select exam pattern`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedClasses) {
        this.$toasted.error(`Please select data type`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedSubjects || data.selectedSubjects.length === 0) {
        this.$toasted.error(`Please select subject`, {
          icon: "info",
        });
        return false;
      } else if (
        data.selectedSubjects &&
        data.selectedSubjects.length
      ) {
        let subjectIds = [];
        let valid = true;

        let subjectDifficulty = [],subjectDiff100 = [] 
        data.selectedSubjects.map((s) => {
          if (!(s.easy||s.moderate||s.tough)) {
            subjectDifficulty.push(s.title)
            valid = false;
          }
          let total = s.easy+s.moderate+s.tough;
          if(total!=100 && !subjectDifficulty.includes(s.title)){
            subjectDiff100.push(s.title)
            valid= false;
          }
          
        });
        if (subjectDifficulty && subjectDifficulty.length) {
          this.$toasted.error(
            `Please select difficulty level for ${subjectDifficulty.join(", ")}`,
            {
              icon: "info",
            }
          );
          
        }
        if (subjectDiff100 && subjectDiff100.length) {
          
          this.$toasted.error(`Please check sum for ${subjectDiff100.join(", ")} should be equal to 100%`, {
            icon: "info",
          });
        }
        if (!valid) {
          return false;
        }
      }
      return true;
    },
    requestGetRefData() {
      let reqData = { keys: ["QUESTION_TYPE"] };
      this.getRefData(reqData)
        .then((response) => {
          this.loading = false;
          this.questionTypes2 = response.QUESTION_TYPE.map((x) => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            c.checked = false;
            return c;
          });
          this.questionTypes = response.QUESTION_TYPE.filter(
            (xx) =>
              xx.id != 14 &&
              xx.id != 15 &&
              xx.id != 16 &&
              xx.id != 17 &&
              xx.id != 18 &&
              xx.id != 20 &&
              xx.id != 21 &&
              xx.id != 23 &&
              xx.id != 24 &&
              xx.id != 8
          ).map((x) => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async processData(data) {
      this.disableCreateTest = true;
      let chapterId = 0,
      questions = [],
      questionNo = 1,
      subIndex = 0,
      optionalQuestionsList = [];
      if (
        this.selectedPatterns &&
        this.selectedPatterns.id !== "custom_pattern" &&
        this.validate(data) 
      ) {  
        this.$root.showLoader = true;
        let subjectChapterId = await this.getChaptersForAllSubjects();
        this.selectedSubjectWithDifficultyLevel.map((s) => {
          let currentSubjectId =
            this.selectedSubjectWithDifficultyLevel &&
            this.selectedSubjectWithDifficultyLevel[0]
              ? this.getSubjectId(this.selectedSubjectWithDifficultyLevel[0])
              : 0;
          let sub_subject;
          this.selectedPatterns.test_params.map((p, index) => {
            if (
              p.question_type_id != this.QUE_TYPES.COMPREHENSION &&
              p.question_type_id != this.QUE_TYPES.TC &&
              p.optional_question &&
              parseInt(p.optional_question.no_of_mandatory_questions) <
                parseInt(p.optional_question.number_of_question) &&
              p.subject_ids.includes(currentSubjectId)
            ) {
              let queData = this.selectedPatterns.test_params[index];
              let newQueData = optionalQuestionsList.findIndex(
                (c) =>
                  c &&
                  c.questionType === queData.question_type_id &&
                  c.subject === this.getSubjectId(s)
              );
              let newMandatoryQueObj = {};
              newMandatoryQueObj = {
                noOfMandatoryQuestions: parseInt(
                  p.optional_question.no_of_mandatory_questions
                ),
                allowAll: parseInt(p.optional_question.allow_all),
                numberOfQuestions: parseInt(
                  p.optional_question.number_of_question
                ),
                mandatoryQuestionId: null,
                questionType: p.question_type_id,
                subType: p.question_subType_id,
                subject: this.getSubjectId(s),
                sub_subject: s && s.code ? s.code : "null",
              };
              optionalQuestionsList.push(newMandatoryQueObj);
            }
            if (currentSubjectId != s.id && !this.checkBiology(s)) {
              currentSubjectId = this.getSubjectId(s);
              // this.duration += p.duration;

              ++subIndex;
            } else if (this.checkBiology(s) && sub_subject !== s.code) {
              sub_subject = s.code;
              ++subIndex;
            }
            if (
              p.subject_ids.includes(this.getSubjectId(s)) ||
              (this.selectedPatterns.id === 15 &&
                ((p.subject_ids[0].length &&
                  p.subject_ids[0].includes(this.getSubjectId(s))) ||
                  (p.subject_ids[1].length &&
                    p.subject_ids[1].includes(this.getSubjectId(s))) ||
                  (p.subject_ids[2].length &&
                    p.subject_ids[2].includes(this.getSubjectId(s))) ||
                  (this.selectedSubjects.length === 1 &&
                    p.subject_ids[2].includes(this.getSubjectId(s)))))
            ) {
              for (let k = 0; k < p.number_of_question; k++) {
                let currentQuestion = {
                  index: questionNo,
                  subIndex: subIndex,
                  subject: s,
                  chapterId: s.code === 'z' ? 1324 : subjectChapterId[s.id].chapterId,
                  selectedSubType: p.question_subType_id,
                  question_text: this.DUMMYTEXT,
                  solution: this.DUMMYTEXT,
                  correct_answer: null,
                  options: [],
                  options_abc: [],
                  options_pqr: [],
                  hints: [{ text: this.DUMMYTEXT }],
                  questions: [],
                  startValue: null,
                  endValue: null,
                  questionType: p.question_type_id,
                  question_type: p.question_type_id,
                  subtype: p.question_subType_id,
                  correctMarkingSchema: p.positive_marks,
                  inCorrectMarkingSchema: p.negative_marks || 0,
                  partialMarking: p.partial_marking,
                  required_questions: parseInt(p.number_of_question),
                  l1_questions_required:s.easy,
                  l2_questions_required:s.moderate,
                  l3_questions_required:s.tough,

                };
                currentQuestion = this.setDummyAnswerAsPerType(currentQuestion);
                questions.push(currentQuestion);
                questionNo++;
              }
            }
          });
        });
        data.duration = this.duration;
        let questionList = questions; //removing getQuestionArray(questions)
         this.createTest(questionList, optionalQuestionsList);
        // console.log(questions);
      } else {

         localStorage.setItem("selectedTarget", this.selectedTarget);
         this.onNextClick({...data});
      }
    },

    createTest(questions, optionalQuestionsList) {
      // let stepOneData = this.data.stepOneData;
      let list = [];
      let forUpdate = false;
      this.$root.showLoader = true;

      questions.map((q, i) => {
        let obj = {
          index: i + 1,
          subIndex: q.subIndex,
          question_text: q.question_text,
          question_type: q.question_type,
          subtype: q.subtype,
          data_type_id: q.chapterId,
          correct_marks: q.correctMarkingSchema,
          negative_marks: q.inCorrectMarkingSchema,
          partial_marking: q.partialMarking,
          required_questions: parseInt(q.required_questions),
          questions: q.questions,
          solution: q.solution,
          noOfMandatoryQuestions: q.noOfMandatoryQuestions,
          subject: this.getSubjectId(q.subject),
          hints: this.getHintsForRequest(q.hints),
          sub_subject: q.subject.code,
        };
        if (q.id) {
          obj.id = q.id;
          forUpdate = true;
        }

        if (
          q.question_type === this.QUE_TYPES.INTEGER ||
          q.question_type === this.QUE_TYPES.SUBJECTIVE ||
          q.question_type === this.QUE_TYPES.SUBJECTIVEINTEGER ||
          q.question_type === this.QUE_TYPES.COMPREHENSION_2Q_NU
        ) {
          obj.correct_answer = q.correct_answer;
        } else {
          obj.correct_answer = "-";
        }
        if (
          q.question_type === this.QUE_TYPES.ASSERTION_REASON ||
          q.question_type === this.QUE_TYPES.MULTIPLE_CORRECT ||
          q.question_type === this.QUE_TYPES.SINGLE_CORRECT_SEC2 ||
          q.question_type === this.QUE_TYPES.SINGLE_CORRECT ||
          q.question_type === this.QUE_TYPES.COMPREHENSION ||
          q.question_type === this.QUE_TYPES.COMPREHENSION_2Q_SA ||
          q.question_type === this.QUE_TYPES.COMPREHENSION_2Q_MA ||
          q.question_type === this.QUE_TYPES.COMPREHENSION_3Q_SA ||
          q.question_type === this.QUE_TYPES.COMPREHENSION_3Q_MA ||
          q.question_type === this.QUE_TYPES.COMPREHENSION_2Q_MM ||
          q.question_type === this.QUE_TYPES.TC ||
          q.question_type === this.QUE_TYPES.TC_3Q_SA ||
          q.question_type === this.QUE_TYPES.TC_2Q_SA
        ) {
          obj.options = q.options;
        } else if (q.question_type === this.QUE_TYPES.MATRIX_MATCH) {
          obj.options = q.options_abc.concat(q.options_pqr);
        } else if (q.question_type === this.QUE_TYPES.MATRIX_MATCH_OPTION) {
          obj.options = q.options.concat(q.options_abc).concat(q.options_pqr);
        }

        list.push(obj);
      });
      let isOnline = localStorage.getItem("isOnlineTest");

      let reqData = {
        list: list,
        target: this.selectedTarget,
        test_type: this.testType ? this.testType : this.TEST_TYPE.CUSTOM,
        test_sub_type: this.TEST_SUB_TYPES.CUSTOM,
        test_pattern: this.selectedPatterns.id,
        duration: this.duration,
        test_name: this.testName,
        optionalQuestionsList: optionalQuestionsList,
        instructions: this.instructions || "",
        pattern: this.selectedPatterns,
        is_online_test: isOnline === "Online" ? 1 : 0,
        hideModuleQues: this.hideModuleQues,
      };
      if (forUpdate) {
        reqData.only_question = true;
      }
      this.createTestAPI(reqData)
        .then((response) => {
          this.loading = false;
          this.$toasted.success(`Success\n${response.msg}`, {
            icon: "check_circle",
          });
          if (forUpdate) {
            this.onClose({ status: false, reloadPreview: true });
          } else {
            this.$router.push({ name: "customized-tests",query:{tab:isOnline} });
            this.setRouteDetails({ routeName:"customized-tests", selectedTab: isOnline });
          }
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
          this.disableCreateTest = false;
        });
    },
    increment(sub,key) {
      let subjects = [...this.selectedSubjectWithDifficultyLevel];
      let index = subjects.findIndex(s => s.id === sub.id);
      let subject = subjects[index];
      subject[key.toLowerCase()] =subject[key.toLowerCase()]<100? subject[key.toLowerCase()] + 1: 100
      subjects[index]=subject;
      this.selectedSubjectWithDifficultyLevel = [...subjects];
      this.updateToughValue(subject);
    },
    decrement(sub,key) {
      let subjects = [...this.selectedSubjectWithDifficultyLevel];
      let index = subjects.findIndex(s => s.id === sub.id);
      let subject = subjects[index];
      subject[key.toLowerCase()] =subject[key.toLowerCase()]> 0 ? subject[key.toLowerCase()] - 1: 0
      subjects[index]=subject;
      this.selectedSubjectWithDifficultyLevel = [...subjects];
       this.updateToughValue(subject);
    },
    sliderChange(sub){
      console.log("coming in slider : ",sub);
      console.log(this.selectedSubjectWithDifficultyLevel,"complete obj");
      let subjects = [...this.selectedSubjectWithDifficultyLevel];
      let index = subjects.findIndex(s => s.id === sub.id);
      let subject = subjects[index];
      subject.easy = constants.DIFFICULTY_PERCENTAGE[subject.difficulty].easy
      subject.moderate = constants.DIFFICULTY_PERCENTAGE[subject.difficulty].moderate
      subject.tough = constants.DIFFICULTY_PERCENTAGE[subject.difficulty].tough
      subjects[index]=subject;
      this.selectedSubjectWithDifficultyLevel = [...subjects];
      console.log(this.selectedSubjectWithDifficultyLevel,"final value");
    },
  },
  watch: {
    selectedTarget(val, oldValue) {
      if (val && val !== oldValue) {
        this.getPatterns();
      }
    },
    selectedPatterns(val, oldValue) {
      if (val && val !== oldValue) {
        this.changePatterns();
      }
    },
  },
  computed: {

    isSelectedSubjectEditted(){
      if (this.selectedSubjectWithDifficultyLevel.length) {
        console.log('yash');
        
        let editedSubject = this.selectedSubjectWithDifficultyLevel?.find(sub => sub.isDisabled === false)
        if(editedSubject){
          return true
        }
        return false
      }
      return false;
    },

    
    isInstructionsAdded() {
      if (
        !this.instructions ||
        this.extractContent(this.instructions, true).trim() === ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    getCategory() {
      return this.classes.filter((c) =>
        this.selectedPatterns && this.selectedPatterns.id !== "custom_pattern"
          ? c.value.id == 3
          : true
      );
    },
  },
};
</script>
<style lang="scss" scoped>

.percentage-input{
  margin-left: 0.15rem;
  padding: 0 0 0 0.25rem;
  width: 35px;
  text-align: right;
   border: 0.75px solid rgba(110, 107, 123, 1);
}
.slider-row{
  margin-bottom: -10px;
  padding: 15px;
  border: 1px solid rgba(110, 107, 123, 0.12);
  box-shadow: 0px 5px 20px rgba(34, 41, 47, 0.1);
  border-radius:6px;
  .sub-block{
    margin-left: 0px;
  }
.slider-outer{
  width: 100%;
  .v-input__slot{
    margin-bottom: -50px;
  }
  .card-text-padding{
    padding: 2px 9px;
  }
}

}
.Select-label-normal.subject-title-slide{
    margin-bottom: 7px;
}
.diff-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0;
}
.pd-diff-7{
  padding: 6px;
}

.max-char{
  display: flex;
  align-self: center;
  justify-content: end;
}
.subject-title-slide {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  font-weight: 600;
  font-size: 1.15rem;
  line-height: 1.2;
  flex-wrap: nowrap;
  .subject-name {
    flex-shrink: 1;
    min-width: 0;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: inherit;
  }
  .edit-btn {
    min-width: auto;
    width: 28px;
    height: 28px;
    padding: 0.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    font-size: 1.1em;
  }
}

@media (max-width: 600px) {
  .subject-title-slide {
    font-size: 0.9rem !important;
  }
  .diff-row .subheading, .diff-label, .diff-row div {
    font-size: 0.75rem !important;
  }
}
@media (max-width: 991px) {
  .subject-title-slide {
    font-size: 0.9rem !important;
  }
  .diff-row .subheading, .diff-label, .diff-row div {
    font-size: 0.75rem !important;
  }
}
@media (max-width: 1279px) {
  .subject-title-slide {
    font-size: 0.9rem !important;
  }
  .diff-row .subheading, .diff-label, .diff-row div {
    font-size: 0.75rem !important;
  }
}
@media all and (max-width: 991px) {
    .percent_pos3{
      padding-bottom: 20px;
    }
  .mb-d-none{
    display: none;
  }
  .custom-test-button{
      flex: 0 0 100%;
      max-width: 100%;
  }
  .mobile-full-outer{
    flex: 0 0 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .diff-min-300{
    min-width: 300px;
  }
}
.outline-prepend-icon{
  border:1px solid #000;
}  
.difficulty-subject {
  display: flex;
  flex-wrap: wrap;
}
.difficulty-col {
  flex: 1 1 0%;
  min-width: 0;
  max-width: 100%;
}
</style>
<style lang="scss">
.hide-error-msg{
  .v-messages{
    display: none;
  }
}
.hide-none {
  display: none;
}
.not-tranform{
  text-transform: none !important;
}
.with-discard-module {
  display: flex;

  > span {
    font-weight: 500;
    font-size: 13px;
  }

  .discard-mod-checkbox {
    margin-left: auto;

    .v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;

      .v-messages {
        display: none;
      }

      .v-input__slot {
        margin-bottom: 0;
      }
    }
  }
}
</style>